import { create } from 'zustand';
import { getProviderTypes } from '../api/providerApi';

const useProviderTypeStore = create((set) => ({
    providerTypes: [],
    loading: false,
    error: null,

    fetchProviderTypes: async () => {
        set({ loading: true, error: null });

        try {
            const result = await getProviderTypes();

            set({
                providerTypes: result.data || [],
                loading: false,
            });
        } catch (err) {
            set({
                error: err.message || 'Something went wrong',
                loading: false,
            });
        }
    },
}));

export default useProviderTypeStore;
